import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 3.5L14.6261 9.0954L20.5 9.99824L16.25 14.3509L17.253 20.5L12 17.5954L6.747 20.5L7.75 14.3509L3.5 9.99824L9.37305 9.0954L12 3.5Z",
		fill: "#FCD34D",
		stroke: "#FCD34D",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgStarFilled);
export default ForwardRef;
